export const primaryColor = '#FF7000'